export default __webpack_public_path__ + "static/media/shoes3.433f34c7.jpg";